import React from 'react'
import envJson from './env.json'
import { profileScreen } from './translates'
import { AppConfig } from './AppConfig'

export const ALL = '*'
export const NEW = 'new'
export const ACCEPTED = 'accepted'
export const ACCEPT = 'accept'
export const ACCEPT_CONDITION = 'acceptCondition'
export const DECLINED = 'declined'
export const FILLED = 'filled'
export const NOT_FILLED = 'notFilled'
export const FILLED_IN_SHOPPER = 'filledInShopper'
export const FILLED_IN_TINKOFF = 'filledInTinkoffId'
export const DELETED = 'deleted'
export const DECLINE = 'decline'
export const NONE = 'none'
export const UNKNOWN_DOC = 'Неизвестный тип документа'
export const STATE_CHECKED = 'Проверен'

export const coordinatorTickStatusTimerMs = 10000
export const COORDINATOR_PARTNER_ID = 'coordinatorPartnerId'

export const maxSizeUploadFileMB = {
  passportPhoto1: 10,
  passportPhoto2: 10,
  passportPhoto3: 10,
  default: 10
}
export const twoMinutes = 2 * 60 * 1000
export const oneMinute = 1 * 60 * 1000
export const getShareLinkPath = shareId => window.location.origin + '/api/public/offer/' + shareId
export const getShopperPath = (phone, host = envJson.partnerActivationHost) => host + envJson.partnerActivationSlug + '?phone=' + phone
export const personalPolicyDocLink = `${envJson.apiEndpoint}public/file/pdpolicy.pdf`
export const personalPolicyMentorLink = `${envJson.apiEndpoint}public/file/pdpolicymentor.pdf`
// export const legalAgeTemplateDocLink = '/img/cooperation_tips.pdf'
export const legalAgeTemplateDocLink = `${envJson.apiEndpoint}partner/underageAgreement`

export const emptyFilter = { text: '<Нет значения>', value: null }

export const laquo = <>&laquo;</>
export const raquo = <>&raquo;</>
export const nbsp = <>&nbsp;</>
export const mdash = <>&mdash;</>

export const policyTypes = {
  personalDataPolicy: 'personalDataPolicy',
  electronicSignaturePolicy: 'electronicSignaturePolicy',
  partnersSberMarketPolicy: 'partnersSberMarketPolicy',
  cyberSecurityPolicy: 'cyberSecurityPolicy',
  assemblyAndDeliveryPolicy: 'assemblyAndDeliveryPolicy',
  lmkAgreement: 'lmkAgreement',
  mentorOffer: 'mentorOffer'
}
export const breadcrumbSeparator = <span className='ant-breadcrumb-separator'>&gt;</span>
export const formLayout = {
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 24 }
  }
}

export const paginationPageSizeList = [10, 20, 50]

export const partnerLinkedFields = {
  [`personalData.${profileScreen.input.surname.name}`]: {
    [profileScreen.input.passportPhoto1.name]: null,
    [profileScreen.input.passportPhoto2.name]: null,
    [profileScreen.input.passportPhotoExtraReg.name]: null,
    [profileScreen.input.bankDetailsPhoto.name]: null,
    [profileScreen.input.innPhoto.name]: null
  },
  [`personalData.${profileScreen.input.firstName.name}`]: {
    [profileScreen.input.passportPhoto1.name]: null,
    [profileScreen.input.passportPhoto2.name]: null,
    [profileScreen.input.passportPhotoExtraReg.name]: null,
    [profileScreen.input.bankDetailsPhoto.name]: null,
    [profileScreen.input.innPhoto.name]: null
  },
  [`personalData.${profileScreen.input.middleName.name}`]: {
    [profileScreen.input.passportPhoto1.name]: null,
    [profileScreen.input.passportPhoto2.name]: null,
    [profileScreen.input.passportPhotoExtraReg.name]: null,
    [profileScreen.input.bankDetailsPhoto.name]: null,
    [profileScreen.input.innPhoto.name]: null
  },
  [`personalData.passport.${profileScreen.input.passportseries.name}`]: {
    [profileScreen.input.passportPhoto1.name]: null,
    [profileScreen.input.passportPhoto2.name]: null,
    [profileScreen.input.passportPhotoExtraReg.name]: null
  },
  [`personalData.passport.${profileScreen.input.passportnumber.name}`]: {
    [profileScreen.input.passportPhoto1.name]: null,
    [profileScreen.input.passportPhoto2.name]: null,
    [profileScreen.input.passportPhotoExtraReg.name]: null
  },
  [`personalData.passport.${profileScreen.input.passportissuerName.name}`]: {
    [profileScreen.input.passportPhoto1.name]: null,
    [profileScreen.input.passportPhoto2.name]: null,
    [profileScreen.input.passportPhotoExtraReg.name]: null
  },
  [`personalData.passport.${profileScreen.input.passportissuerCode.name}`]: {
    [profileScreen.input.passportPhoto1.name]: null,
    [profileScreen.input.passportPhoto2.name]: null,
    [profileScreen.input.passportPhotoExtraReg.name]: null
  },
  [`personalData.passport.${profileScreen.input.passportissueDate.name}`]: {
    [profileScreen.input.passportPhoto1.name]: null,
    [profileScreen.input.passportPhoto2.name]: null,
    [profileScreen.input.passportPhotoExtraReg.name]: null
  },
  [`personalData.${profileScreen.input.inn.name}`]: {
    [profileScreen.input.innPhoto.name]: null
  },
  [`bankDetails.${profileScreen.input.bankAccount.name}`]: {
    [profileScreen.input.bankDetailsPhoto.name]: null
  },
  [`bankDetails.${profileScreen.input.bankBik.name}`]: {
    [profileScreen.input.bankDetailsPhoto.name]: null
  },
  [`bankDetails.${profileScreen.input.bankName.name}`]: {
    [profileScreen.input.bankDetailsPhoto.name]: null
  },
  [profileScreen.input.passportPhoto1.name]: {
    personalData: {
      passport: {
        [profileScreen.input.passportseries.name]: null,
        [profileScreen.input.passportnumber.name]: null,
        [profileScreen.input.passportissuerName.name]: null,
        [profileScreen.input.passportissuerCode.name]: null,
        [profileScreen.input.passportissueDate.name]: null
      }
    }
  },
  [profileScreen.input.passportPhoto2.name]: {
    personalData: {
      passport: {
        [profileScreen.input.passportseries.name]: null,
        [profileScreen.input.passportnumber.name]: null,
        [profileScreen.input.passportissuerName.name]: null,
        [profileScreen.input.passportissuerCode.name]: null,
        [profileScreen.input.passportissueDate.name]: null
      }
    }
  },
  [profileScreen.input.bankDetailsPhoto.name]: {
    bankDetails: {
      [profileScreen.input.bankAccount.name]: null
    }
  }
}

export const partnerListColKeys = {
  registrationDate: 'registrationDate',
  statuses: 'statuses',
  formStatuses: 'formStatuses',
  cardStatuses: 'cardStatuses',
  bankRequisiteFormStatuses: 'bankRequisiteFormStatuses',
  smzStatuses: 'smzStatuses',
  youdoStatuses: 'youdoStatuses',
  roles: 'roles',
  name: 'name',
  mobilePhone: 'mobilePhone',
  cityIds: 'cityIds',
  storeName: 'storeName',
  offerExpires: 'offerExpires',
  verificationStatuses: 'verificationStatuses',
  payoutSuspended: 'payoutSuspended',
  lmkFormStatuses: 'lmkFormStatuses',
  employmentTypeFormStatuses: 'employmentTypeFormStatuses',
  fireBriefingFormStatuses: 'fireBriefingFormStatuses',
  inn: 'inn',
  statusTimestamp: 'statusTimestamp',
  legalForms: 'legalForms'
}

export const rolePartnerListColsKeys = {
  defaultGroup: Object.keys(partnerListColKeys).filter(
    k => ![
      partnerListColKeys.inn,
      partnerListColKeys.lmkFormStatuses,
      partnerListColKeys.fireBriefingFormStatuses,
      partnerListColKeys.statusTimestamp
    ].includes(k)
  ),
  [AppConfig.groups.supervisors]: Object.keys(partnerListColKeys).filter(
    k => ![partnerListColKeys.inn, partnerListColKeys.statusTimestamp].includes(k)
  ),
  [AppConfig.groups.citymanagers]: Object.keys(partnerListColKeys).filter(
    k => ![partnerListColKeys.inn, partnerListColKeys.statusTimestamp, partnerListColKeys.lmkFormStatuses].includes(k)
  ),
  [AppConfig.groups.personalmanagers]: Object.keys(partnerListColKeys).filter(
    k => ![
      partnerListColKeys.inn,
      partnerListColKeys.lmkFormStatuses,
      partnerListColKeys.formStatuses,
      partnerListColKeys.cardStatuses,
      partnerListColKeys.payoutSuspended,
      partnerListColKeys.statusTimestamp
    ].includes(k)
  ),
  [AppConfig.groups.contentcoordinators]: Object.keys(partnerListColKeys).filter(
    k => ![
      partnerListColKeys.inn,
      partnerListColKeys.lmkFormStatuses,
      partnerListColKeys.cardStatuses,
      partnerListColKeys.roles,
      partnerListColKeys.cityIds,
      partnerListColKeys.storeName,
      partnerListColKeys.offerExpires,
      partnerListColKeys.verificationStatuses,
      partnerListColKeys.formStatuses
    ].includes(k)
  ),
  [AppConfig.groups.researchercoordinators]: Object.keys(partnerListColKeys).filter(
    k => ![
      partnerListColKeys.inn,
      partnerListColKeys.lmkFormStatuses,
      partnerListColKeys.cardStatuses,
      partnerListColKeys.roles,
      partnerListColKeys.cityIds,
      partnerListColKeys.storeName,
      partnerListColKeys.offerExpires,
      partnerListColKeys.verificationStatuses,
      partnerListColKeys.formStatuses
    ].includes(k)
  ),
  [AppConfig.groups.operatorcoordinators]: Object.keys(partnerListColKeys).filter(
    k => ![
      partnerListColKeys.inn,
      partnerListColKeys.lmkFormStatuses,
      partnerListColKeys.cardStatuses,
      partnerListColKeys.roles,
      partnerListColKeys.cityIds,
      partnerListColKeys.storeName,
      partnerListColKeys.offerExpires,
      partnerListColKeys.verificationStatuses,
      partnerListColKeys.formStatuses
    ].includes(k)
  ),
  [AppConfig.groups.kuperMentor]: Object.keys(partnerListColKeys).filter(
    k =>
      ![
        partnerListColKeys.registrationDate,
        partnerListColKeys.legalForms,
        partnerListColKeys.roles,
        partnerListColKeys.cityIds
      ].includes(k)
  )
}

export const initialBannedPartnerColKeys = [
  partnerListColKeys.registrationDate,
  partnerListColKeys.statuses,
  partnerListColKeys.youdoStatuses,
  partnerListColKeys.roles,
  partnerListColKeys.name,
  partnerListColKeys.mobilePhone,
  partnerListColKeys.storeName,
  partnerListColKeys.statusTimestamp
]

export const partnerRoles4MultiOffer = [
  AppConfig.partnerRoles.packer,
  AppConfig.partnerRoles.courier,
  AppConfig.partnerRoles.footCourier,
  AppConfig.partnerRoles.automotiveCourier,
  AppConfig.partnerRoles.packerAndFootCourier,
  AppConfig.partnerRoles.packerAndAutomotiveCourier,
  AppConfig.partnerRoles.bikeCourier,
  AppConfig.partnerRoles.automotiveCourierOnDemand
]

export const legalAgeCapable = {
  listTrue: [
    profileScreen.input.legalCapacityConfirmation.name
  ],
  listFalse: [
    profileScreen.input.trusteeAgreement.name,
    profileScreen.input.trusteePassport.name,
    profileScreen.input.trusteeConfirmation.name
  ]
}

export const disabledBtnSeconds = 5 * 60

export const storageKeys = {
  cooldownBtnStatusConfirmation: 'cooldown-btn-status-confirmation',
  cooldownBtnLastStepPartner: 'cooldown-btn-last-step-partner',
  cooldownActiveSelfEmployedStatus: 'cooldown-btn-active-self-employedStatus'
}
